"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class;

var PDF = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(PDF, _Activity);

  function PDF() {
    babelHelpers.classCallCheck(this, PDF);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PDF).apply(this, arguments));
  }

  babelHelpers.createClass(PDF, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      this.$().addClass('pdf-activity');
      this.addEventListener('startedActivity', this._pdfStarted);
      this.addEventListener('timerExpired', function () {
        return _this.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.startActivity();

      if (this.readOnly) {
        this.activityComplete();
      }
    }
  }, {
    key: "_pdfStarted",
    value: function _pdfStarted(event) {
      var _this2 = this;

      var options = {},
          PDF = event.activity.details.PDF;
      var promise;

      if ('activityId' in PDF) {
        promise = (0, _fetch.default)("access/".concat(PDF.activityId)).then(function (data) {
          return data.json();
        });
      } else {
        promise = _promisePolyfill.default.resolve({
          access: 'enabled',
          detail: {
            signedDocumentURL: PDF.file,
            password: PDF.password
          }
        });
      }

      promise.then(function (access) {
        if (Number(PDF.toolbar)) {
          var OL = Object.keys(PDF).filter(function (v) {
            return /^toolbar/.test(v) && Number(PDF[v]);
          }).map(function (v) {
            return v.substring('toolbar'.length).toLowerCase();
          });
          options.controls = OL.join(',');
        } else {
          options.toolbar = 'false';
        }

        options.file = access.detail.signedDocumentURL;
        if (access.detail.password) options.password = access.detail.password;
        var qs = Object.keys(options).map(function (v) {
          return [v, options[v]].map(encodeURIComponent).join('=');
        }).join('&');

        _this2.$('.activity-body.pdf').css({
          position: 'relative',
          height: '100vh'
        });

        _this2.$('.pdf-body-area').css({
          position: 'static'
        }).find('.pdf-viewer').remove();

        _this2.$('.pdf-body-area').append("\n\t\t\t\t<iframe class='pdf-viewer' mozallowfullscreen webkitallowfullscreen allowfullscreen width='1280' height='720' src='/admin/platform/plugins/".concat(PDF.pluginId, "/libraries/pdf.js/web/viewer.html?").concat(qs, "' frameborder='0'></iframe>\n\t\t\t"));

        _this2.$('iframe').css({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        }).focus();

        if (!_this2.readOnly) {
          _this2.startTimer(event.activity.endTime ? new Date(event.activity.endTime).getTime() - new Date(event.activity.startTime).getTime() : 10000, true);
        }
      });
    }
  }]);
  return PDF;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_pdfStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_pdfStarted"), _class.prototype)), _class);
exports.default = PDF;